var strings = require('../../strings/strings.en.json');

const getAppStrings = errorCode => {
  const string = strings['in-app-dialogues'].find(
    ({ code }) => errorCode === code
  );
  return string;
};

export default getAppStrings;
